var map = {
	"./Angry.png": 3712,
	"./Easy.png": 5872,
	"./Funny.png": 42,
	"./Good.png": 8342,
	"./InLove.png": 9920,
	"./Neutral.png": 2900,
	"./OK.png": 9327,
	"./Sad.png": 5687,
	"./Sick.png": 9190,
	"./Surprised.png": 2642,
	"./VerySad.png": 5653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4807;